import * as React from 'react';

const Ro24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#CE2B37", d: "M15 18h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-4z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FECC00", d: "M9 18h6V6H9z" }), /* @__PURE__ */ React.createElement("path", { fill: "#002B7F", d: "M3 16a2 2 0 0 0 2 2h4V6H5a2 2 0 0 0-2 2z" }));
Ro24.Size = 24;
Ro24.Title = "Ro";

export { Ro24 as default };
